
import BaseForm from '@/components/base/BaseForm'
import {Component, Prop} from 'vue-property-decorator'
import {namespace} from 'vuex-class'

const uiModule = namespace('ui')

@Component
export default class BaseFormContainer extends BaseForm {
  @Prop(Boolean) disabledSubmitAction: false
  @Prop(Boolean) hideCancelAction: false
  @Prop(String) customLabelSubmit: null
  @Prop(String) customLabelCancel: null

  @uiModule.Getter('isLoadingGetter') isLoading: any

  get labelSubmit() {
    return this.customLabelSubmit ? this.customLabelSubmit : 'Enregistrer'
  }

  get labelCancel() {
    return this.customLabelCancel ? this.customLabelCancel : 'Annuler'
  }
}
